import React from 'react'
import { StyledWrapper, StyledText } from './styles'

const NotAllowed = () => (
  <StyledWrapper>
    <StyledText>
      It is not allowed to delete conversions in bulk from campaigns where
      report type is set to with timestamps, as this is a high risk action.
      <br />
      If you need to delete a large number of conversions from this campaign,
      please create a tech request & explain what needs to be deleted and why.
    </StyledText>
  </StyledWrapper>
)

export default NotAllowed
